"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataProcessingWithConsentContent = void 0;
const lib_1 = require("@brandfree-front/lib");
const react_1 = __importDefault(require("react"));
const PublicPrivacyNoticeModalContentUtil_1 = require("./PublicPrivacyNoticeModalContentUtil");
const RootStore_1 = require("../../../stores/RootStore");
const DataProcessingWithConsentContent = () => {
    const { translate } = react_1.default.useContext(RootStore_1.RootStoreContext).translateStore;
    const dataProcessingWithConsentRows = [
        {
            content: translate('gdpr.privacy.notification.paragraph.data.processing.with.content.tablerow1'),
            type: translate('gdpr.privacy.notification.paragraph.data.processing.content.basic.data')
        },
        {
            content: translate('gdpr.privacy.notification.paragraph.data.processing.with.content.tablerow2'),
            type: translate('gdpr.privacy.notification.paragraph.data.processing.content.basic.data')
        },
        {
            content: translate('gdpr.privacy.notification.paragraph.data.processing.with.content.tablerow3'),
            type: `${translate('gdpr.privacy.notification.paragraph.data.processing.content.basic.data')}, ${translate('gdpr.privacy.notification.paragraph.data.processing.content.traffic.data')}`
        },
        {
            content: translate('gdpr.privacy.notification.paragraph.data.processing.with.content.tablerow4'),
            type: `${translate('gdpr.privacy.notification.paragraph.data.processing.content.basic.data')}, ${translate('gdpr.privacy.notification.paragraph.data.processing.content.traffic.data')}`
        },
        {
            content: translate('gdpr.privacy.notification.paragraph.data.processing.with.content.tablerow5'),
            type: translate('gdpr.privacy.notification.paragraph.two.special.data')
        }
    ];
    return (react_1.default.createElement(lib_1.Text, null,
        react_1.default.createElement("p", null, translate('gdpr.privacy.notification.paragraph.data.processing.with.content.text1')),
        react_1.default.createElement("p", null, translate('gdpr.privacy.notification.paragraph.data.processing.with.content.text2')),
        react_1.default.createElement(PublicPrivacyNoticeModalContentUtil_1.DataProcessingTable, { data: dataProcessingWithConsentRows }),
        react_1.default.createElement("p", null, translate('gdpr.privacy.notification.paragraph.data.processing.with.content.text3')),
        react_1.default.createElement("p", null, translate('gdpr.privacy.notification.paragraph.data.processing.with.content.text4')),
        react_1.default.createElement("p", null, translate('gdpr.privacy.notification.paragraph.data.processing.with.content.text5')),
        react_1.default.createElement("p", null, translate('gdpr.privacy.notification.paragraph.data.processing.with.content.text6'))));
};
exports.DataProcessingWithConsentContent = DataProcessingWithConsentContent;
